import { render, staticRenderFns } from "./service_details.vue?vue&type=template&id=775c7bdc&scoped=true&"
import script from "./service_details.vue?vue&type=script&lang=js&"
export * from "./service_details.vue?vue&type=script&lang=js&"
import style0 from "./service_details.vue?vue&type=style&index=0&id=775c7bdc&scoped=true&lang=css&"
import style1 from "./service_details.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775c7bdc",
  null
  
)

export default component.exports